import { FETCH_SEEDFUND_REPORT } from '../../constants/actionConstants';

const initialState = {
    seedfundReportData: []
};

export default (state = initialState, action) => {

    let newState;
    switch (action.type) {

        case FETCH_SEEDFUND_REPORT:
            newState = {
                ...state,
                seedfundReportData: action.payload
            };
            return newState;
        default:
            return state;
    }
}
